/**
 * 取扱い不可商品
 */
const ProductsNotAvailable = {
  /** 輸禁 */
  EMBARGO: '1',
  /** 特定毒物 */
  SPECIFIC_POISON: '4',
  /** 要確認 */
  CONFIRMATION_REQUIRED: '9',
} as const;

type ProductsNotAvailable = typeof ProductsNotAvailable[keyof typeof ProductsNotAvailable];

export function getCodeList() {
  const arr = Array<string>();
  arr.push('1');
  arr.push('4');
  arr.push('8');
  return arr;
}
export default ProductsNotAvailable;
